<template>
    <div class="row">
        <MedicineTransaction />
    </div>
</template>

<script>
import MedicineTransaction from '@/components/medicine/MedicineTransaction.vue';
export default {
    name: 'MedicineInput',
    components: { MedicineTransaction },
}
</script>